/**
 * Generate breadcrumbs from current pathname
 * @param {string} pathname - Current location pathname
 * @returns {Array} Array of breadcrumb objects
 */
export const generateBreadcrumbs = (pathname) => {
  const paths = pathname.split("/").filter(Boolean);
  const breadcrumbs = [];

  paths.forEach((path, index) => {
    const label = path.charAt(0).toUpperCase() + path.slice(1);
    breadcrumbs.push({
      label: label,
      isLast: index === paths.length - 1,
    });
  });

  return breadcrumbs.length > 0
    ? breadcrumbs
    : [{ label: "Dashboard", isLast: true }];
};

/**
 * Get page title from breadcrumbs
 * @param {Array} breadcrumbs - Array of breadcrumb objects
 * @returns {string} Page title
 */
export const getPageTitle = (breadcrumbs) => {
  return breadcrumbs[breadcrumbs.length - 1]?.label || "Dashboard";
};
